module.exports = __webpack_public_path__ + "img/merit-image_03.39fed706.jpg";